import { UnauthenticatedTemplate, AuthenticatedTemplate } from "@azure/msal-react"
import AuthRedirect from "./AuthRedirect"
import { useEffect, useState } from "react"
import { useMsal } from "@azure/msal-react"
import { fetchUserInfo } from "../../actions/entra"
import { connect } from 'react-redux'

const EntraContainer = ({ children, fetchUserInfo }) => {
  const { instance } = useMsal()
  const activeAccount = instance.getActiveAccount()

  useEffect(() => {
    if (activeAccount) {
      fetchUserInfo(activeAccount)
    }
  }, [activeAccount, fetchUserInfo])

  //console.log({ userData })

  return (
    <>
      <UnauthenticatedTemplate>
        <AuthRedirect />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        {children}
      </AuthenticatedTemplate>
    </>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUserInfo: (getInfo) => fetchUserInfo(getInfo)(dispatch)
  }
}

export default connect(null, mapDispatchToProps)(EntraContainer)